module.exports = __webpack_public_path__ + "img/矢印アイコン左4_1.5cdf50e0.svg";